// De geluidsmix: drie kanalen met elk een niveau. DOM-vrij, zodat de keuzes en hun volume te testen zijn.
// Het hoofdgeluid (Aan/Uit, instelling `sound`) staat erboven: staat dat uit, dan hoor je niets.

export type SoundLevel = 'uit' | 'zacht' | 'normaal';
export const SOUND_LEVELS: readonly SoundLevel[] = ['uit', 'zacht', 'normaal'];

/** Kanalen in de SoundEngine. */
export type SoundChannel = 'motor' | 'alarm' | 'effects';

/** Welke instelling bij welk kanaal hoort. */
export const SOUND_SETTINGS = {
  soundMotor: 'motor',
  soundAlarm: 'alarm',
  soundEffects: 'effects',
} as const satisfies Record<string, SoundChannel>;

export type SoundSettingKey = keyof typeof SOUND_SETTINGS;

const GAIN: Record<SoundLevel, number> = { uit: 0, zacht: 0.35, normaal: 1 };

/** Het volume (0 tot 1) bij een niveau. Een onbekend niveau telt als normaal. */
export const levelGain = (level: unknown): number => GAIN[level as SoundLevel] ?? 1;
